<template>
    <div class="data-empty">
        <img :src="icon" width="80px" />
        <h3>{{ title }}</h3>
        <p>{{ subtitle }}</p>
    </div>
</template>

<script>
    export default {
        name: 'loading',
        props: ['icon', 'title', 'subtitle']
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .data-empty
        text-align center
        padding 80px 0

        h3
            color $secondary
            margin 0

        p
            margin 0

</style>
